/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RotateCCWBoldIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rotate CCW Bold',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2A16.03 16.03 0 0 0 4.644 9.228L1 7.521a.69.69 0 0 0-.531-.027.7.7 0 0 0-.424.9L3.053 16.7a.5.5 0 0 0 .589.276l8.311-3.008a.7.7 0 0 0 .42-.9.686.686 0 0 0-.361-.39l-3.677-1.72a11.971 11.971 0 1 1-.161 13.917 2 2 0 0 0-3.274 2.3A16 16 0 1 0 18 2Z"
    />
  </svg>`;
};
